"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const companyQuery_1 = require("../../../../../queries/companyQuery");
const userQuery_1 = require("../../../../../queries/userQuery");
const defaultExpirationDateFeatureToggle_1 = __importDefault(require("./defaultExpirationDateFeatureToggle"));
const domainWhitelistingFeatureToggle_1 = __importDefault(require("./domainWhitelistingFeatureToggle"));
const TransactionReceiptUploadfeatureToggle = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./transactionReceiptUploadFeatureToggle'))));
const ProviderMappingFeatureToggle = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./providerMappingFeatureToggle'))));
const LeftSideCompanyFeatures = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: user } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.user,
    });
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(user.companyAccountId, { cardprovider: 'tsgo-cardprovider' }));
    const isHsbcCardProvider = companyPropertiesData?.cardprovider === 'HSBC';
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 6, children: [isHsbcCardProvider ? null : ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(TransactionReceiptUploadfeatureToggle, {}) })), (0, jsx_runtime_1.jsx)(defaultExpirationDateFeatureToggle_1.default, {}), (0, jsx_runtime_1.jsx)(domainWhitelistingFeatureToggle_1.default, {}), isHsbcCardProvider ? null : ((0, jsx_runtime_1.jsx)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)("div", {}), children: (0, jsx_runtime_1.jsx)(ProviderMappingFeatureToggle, {}) }))] }));
};
exports.default = (0, react_1.memo)(LeftSideCompanyFeatures);
